import React from "react";
import {Card} from "../global/Card";

export const StayInTouch = (props) => {

  const data = props.data || {};

  const cardsData = data.items || {}

  const renderCards = () => {
    return cardsData.map((card, index) => (
      <div className="col-lg-4" key={index}>
        <Card
          color={card.color}
          label={card.label}
          text={card.text}
          button={card.button}
          classes="mb-lg-0 mb-4"
        />
      </div>
    ))
  }

  return (
    <section className="py-11">
      <div className="container">
        <span className="zg-label bg-pink me-2">{data.title}</span>
        <div className="row">
          <div className="col-lg-7 col-md-12">
            <h2 className="h3 mb-8 mt-6 letter-spacing-4">{data.subtitle}</h2>
          </div>
        </div>
        <div className="row">
          {renderCards()}
        </div>
      </div>
    </section>
  )
}
